import React from "react";
import { useHistory, useParams, Switch, Route } from "react-router-dom";
import styles from "./styles.module.css";

export default PageMsnAngel;

const albums = [
   { name: "Archive 7", year: "2026", tracks: 26, id: "7J5WHzChdb36MO9PZvFCyS" },
   { name: "Cyber City", year: "2026", tracks: 8, id: "4o4vVZwNKUaNiJqOgdZIR6" },
   { name: "Archive 6", year: "2025", tracks: 33, id: "6vd1nEs7CP83bTCHRF4LDx" },
   { name: "Jeg møtte et spøkelse", year: "2025", tracks: 1, id: "5MOfSEPiplbdcRuhiMeqW5" },
   { name: "Archive 5", year: "2025", tracks: 30, id: "0cgIRsE0bcgwYFkNZ9Pyb4" },
   { name: "Archive 4", year: "2025", tracks: 19, id: "4lqgfiWXguabqNtMtxiG4W" },
   { name: "Archive 3", year: "2025", tracks: 35, id: "0KUNCm3W4hBNgdjKVVH4gE" },
   { name: "Archive 2", year: "2025", tracks: 33, id: "5zSlVUophOPNPOHhoCTLlF" },
   { name: "Archive 1", year: "2025", tracks: 30, id: "0HFuQq3V7dKzbPw9MvVyZ9" },
   { name: "userh309", year: "2018", tracks: 26, id: "2nw62TzFtLGGE3UVJHBZJE" },
   { name: "hotel florida", year: "2017", tracks: 15, id: "2xSefP7bV8tb57CXKUpnEa" },
   { name: "Taxi Bear", year: "2017", tracks: 4, id: "267l4kEncX5yCUSJAygV8K" },
   { name: "lost in the dark", year: "2016", tracks: 14, id: "7y4CeQljZYWZG3cfGyjRYz" },
   { name: "Urban Texas Cowboy", year: "2015", tracks: 9, id: "6KUh60efOvi6ceVd3NxiGX" },
];

function AlbumView() {
   const { albumId } = useParams<{ albumId: string }>();
   const history = useHistory();
   const album = albums.find(a => a.id === albumId);
   if (!album) return <div>Album not found</div>;

   return (
      <div>
         <div
            className={styles.detailRow}
            onClick={() => history.push("/msn-angel")}
            style={{ borderBottom: "2px solid #808080", marginBottom: "4px" }}
         >
            <span className={styles.detailName}>⬅ Back</span>
         </div>
         <iframe
            title={album.name}
            style={{ borderRadius: 0, border: "none" }}
            src={`https://open.spotify.com/embed/album/${album.id}?utm_source=generator&theme=0`}
            width="100%"
            height="380"
            frameBorder="0"
            allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
            loading="lazy"
         />
      </div>
   );
}

function AlbumList() {
   const history = useHistory();

   return (
      <div>
         <div className={styles.detailHeader}>
            <span className={styles.detailName}>Name</span>
            <span className={styles.detailType}>Tracks</span>
         </div>
         {albums.map((album) => (
            <div
               key={album.id}
               className={styles.detailRow}
               onClick={() => history.push(`/msn-angel/${album.id}`)}
            >
               <span className={styles.detailName}>
                  <span className={styles.detailRowIcon}>📁</span>
                  {album.name} ({album.year})
               </span>
               <span className={styles.detailType}>{album.tracks} songs</span>
            </div>
         ))}
      </div>
   );
}

function PageMsnAngel() {
   return (
      <Switch>
         <Route exact path="/msn-angel">
            <AlbumList />
         </Route>
         <Route path="/msn-angel/:albumId">
            <AlbumView />
         </Route>
      </Switch>
   );
}
